import React from 'react';
import {
  Bar,
  XAxis,
  LabelList,
  Label,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
} from 'recharts';
import { useFormatMessage } from 'components/IntlProvider';
import Tooltips from 'components/Charts/Tooltips';

// TODO: add proper types after implementation real data
interface BrandEquityProps {
  data: any;
}

const BrandEquity = ({ data }: BrandEquityProps) => {
  const t = useFormatMessage();
  const preparedData = data.map((singleData: any) => ({
    ...singleData,
    influencer: singleData.influencer * 100,
  }));

  const customizedLabel = (props: any) => {
    const { x, y, value } = props;
    return (
      <g>
        <circle cx={x} cy={y} r={12} fill="#8884d8"></circle>
        <text
          x={x}
          y={y}
          fill="#fff"
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {Math.round(value)}
        </text>
      </g>
    );
  };

  return (
    <ResponsiveContainer width="100%" minHeight="300px">
      <BarChart
        data={preparedData}
        layout="vertical"
        margin={{
          top: 20,
          right: 20,
          bottom: 20,
          left: 20,
        }}
      >
        <CartesianGrid stroke="#f5f5f5" />
        <YAxis
          dataKey="equity"
          type="number"
          reversed
          domain={[
            (val: any) => {
              return (val - 5).toFixed(2);
            },
            (val: any) => {
              return (val + 5).toFixed(2);
            },
          ]}
        >
          <Label
            angle={270}
            position="left"
            style={{ textAnchor: 'middle' }}
            value="Brand Equity Score"
          />
        </YAxis>
        <XAxis type="number" unit="%">
          <Label
            value="Influencer score"
            offset={-10}
            position="insideBottom"
          />
        </XAxis>

        <Tooltip content={<Tooltips.BrandEquity t={t} />} />

        <Bar dataKey="influencer" barSize={1} fill="#413ea0">
          <LabelList dataKey="equity" content={customizedLabel} />
          <LabelList dataKey="name" position="right" />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BrandEquity;
